module.exports = __webpack_public_path__ + "static/media/product-small-01.fe3200d7.png";